import { cardDescriptions } from "@/mocks/caseStudyCards";

/* The address of each case study, the address it had before and the title of
   its browser tab.

   The addresses changed on 5 October 2026 so that they say what the page is
   (Project doc revised-copy/urls-and-meta.md, agreed with Lorenzo). The old
   ones are in CVs, on LinkedIn and in applications he has sent, so each of
   them still opens its page: the router sends `was` to `path`.

   `title` is the title of the browser tab and of a search result, without the
   " | Lorenzo Bernardi" ending that usePageMeta adds. It is not always the
   heading of the page: the Meta-Product one is shorter, so a search engine
   does not cut it. The description of a page is the description of its card
   (src/mocks/caseStudyCards.ts), so a case study has one description
   everywhere. */
export interface CasePage {
  path: string;
  /** The address of the page until 5 October 2026. */
  was?: string;
  title: string;
}

export const CASE_PAGES: CasePage[] = [
  { path: "/skilllab-guardians-feature", was: "/skilllab", title: "SkillLab: UX Advocacy in a Zero-to-One Feature" },
  { path: "/skilllab-counselor-portal", was: "/pmp", title: "SkillLab: Revamping the Counselor Portal" },
  { path: "/skilllab-accessibility", was: "/accessibility", title: "SkillLab's Systemic Accessibility" },
  { path: "/skilllab-design-system", was: "/sds", title: "SkillLab Design System: Governance for a Small Team" },
  { path: "/meta-product", was: "/ai-copilot", title: "Meta-Product: This Portfolio Built with AI" },
  { path: "/portfolio-design-system", title: "The Design System Behind This Portfolio" },
];

/** Every address that is a case study: the header marks "Projects" on these. */
export const CASE_PATHS = CASE_PAGES.map((page) => page.path);

/** Old address and the address it leads to now. */
export const MOVED_PAGES = CASE_PAGES.filter((page) => page.was).map((page) => ({ from: page.was as string, to: page.path }));

export function casePageMeta(path: string) {
  const page = CASE_PAGES.find((p) => p.path === path);
  if (!page) throw new Error(`No case study at ${path}`);
  return { title: page.title, description: cardDescriptions[path], path };
}
